import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { updateHiddenCode } from "../../../redux/slices/menu";
import { constants } from "../../../constants";
import { useState } from "react";

type Props = {
  hideOutline?: boolean;

  minimize?: string;
};

const RoomCode: React.FC<Props> = ({ hideOutline }: Props) => {
  const codeHidden = useAppSelector((state) => state.menu.hiddenCode);
  const roomCode = useAppSelector((state) => state.menu.playerId?.room_code);

  const [hidden, setHidden] = useState(codeHidden);

  const dispatch = useAppDispatch();

  function handleClick() {
    dispatch(updateHiddenCode(!codeHidden));

    if (hideOutline) {
      setHidden((h) => !h);
    }
  }

  function content() {
    if (roomCode) {
      return (
        <label
          className={
            hideOutline
              ? "flex flex-row p-0.5 items-center leading-none text-xl relative bg-night-primary text-center z-10 shadow-basicSmall cursor-pointer border-black border border-l-0"
              : "basis-24 border-2 border-black border-b-0 flex flex-row justify-center items-center px-1 leading-none text-xl relative self-end bg-night-primary text-center z-10 min-h-[2rem] sm:shadow-aestheticTop cursor-pointer"
          }
          onClick={handleClick}
        >
          <span
            className={
              "select-none text-center align-middle px-0 text-xl flex justify-center items-center leading-none"
            }
          >
            {!hidden && constants.key}
          </span>
          <span
            className={
              "align-middle text-center text-xl flex justify-center items-center leading-none"
            }
          >
            {hidden ? constants.littleTriangle : codeHidden ? "****" : roomCode}
          </span>
        </label>
      );
    } else {
      return <></>;
    }
  }

  return content();
};

export default RoomCode;
